module.exports = __webpack_public_path__ + "static/media/slide4.b4f2c144.jpg";